const SubmittedForL4PlanDate = (initiative) => {
    if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
      return null;
    }
    const l1Entry = initiative.timeline.find((entry) => entry.stage === 'Submitted for L4 Approval');
    if(!new Date(l1Entry.date.actual)){
        return null;
    }
    return new Date(l1Entry.date.actual);
  };
  
  export default SubmittedForL4PlanDate;
  